import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import "./index.css";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);
const DivSelectLimit = styled.div`
  width: ${(props) => props.barlength * 120}px;
  margin-left: 0rem;
  padding-bottom: 8px;
  height: 100%;
`;
export const options = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: "bottom",
  },
  scales: {
    yAxes: [
      {
        id: "x-axis-0",
        gridLines: {
          color: "gray",
          zeroLineColor: "gray",
        },
      },
    ],
    x: {
      display: false,
      grid: {
        display: true,
      },
      ticks: {
        display: false,
      },
    },
    y: {
      display: false,
      suggestedMin: 0,
      suggestedMax: 100,
      grid: {
        display: false,
        borderDash: [0.5, 0.5], // Sets the y-axis grid lines to be dotted
      },
      ticks: {
        display: false,
      },
    },
  },
  // borderWidth: {
  //   top: 0,
  //   left: 10,
  //   right: 10,
  //   bottom: 0,
  // },
  borderRadius: {
    topLeft: 8,
    topRight: 8,
    bottomLeft: 8,
    bottomRight: 8,
  },
  borderColor: "gray",
  plugins: {
    legend: {
      display: false, // This hides all text in the legend and also the labels.
    },
    datalabels: {
      anchor: "end",
      align: "top",
      display: true,
      formatter: function (value) {
        return value != undefined ? value : null;
      },
    },
    zoom: {
      pan: {
        enabled: true,
        mode: "x",
        scaleMode: "x",
        // pan options and/or events
      },
      limits: {
        x: { min: 0, max: 4 },
      },
      zoom: {
        enabled: false,
        mode: "x",
        scaleMode: "x",
        wheel: {
          enabled: false,
        },
        // zoom options and/or events
      },
    },
    title: {
      display: false,
      text: "Test performance",
    },
    tooltip: {
      backgroundColor: "#FAFAFA",
      titleColor: "black",
      bodyColor: "black",
    },
  },
};

function BarChat(props) {
  console.log(props, "BarChat");
  const { barLabel, data, avgData, topperData } = props;
  const [barData, setBarData] = useState({
    labels: barLabel,
    datasets: [
      {
        categoryPercentage: 0.7,
        barPercentage: 1.8,
        maxBarThickness: 14,
        minBarLength: 10,
        skipNull: true,
        label: "",
        data: avgData,
        backgroundColor: "#E2E2E2",
      },
      {
        categoryPercentage: 0.7,
        barPercentage: 1.8,
        maxBarThickness: 14,
        minBarLength: 10,
        skipNull: true,
        label: "",
        data: data,
        backgroundColor: "#00b0f5",
      },
      {
        categoryPercentage: 0.7,
        barPercentage: 1.8,
        maxBarThickness: 14,
        minBarLength: 10,
        skipNull: true,
        label: "",
        data: topperData,
        backgroundColor: "#FFE0A3",
      },
    ],
  });
  const performanceChartRef = useRef(null);
  useEffect(() => {
    const bardatas = [...barData.datasets];
    if (bardatas.length > 0) {
      bardatas[1] = { ...bardatas[1], data: data };
    }
    if (bardatas.length > 0) {
      bardatas[0] = { ...bardatas[0], data: avgData };
    }
    if (bardatas.length > 0) {
      bardatas[2] = { ...bardatas[2], data: topperData };
    }
    setBarData({ ...barData, labels: barLabel, datasets: bardatas });
  }, [data, avgData, topperData]);
  // const [width, setWidth] = useState(0);
  // useEffect(() => {
  //   if (
  //     performanceChartRef.current &&
  //     performanceChartRef.current.scrollWidth >
  //       performanceChartRef.current.clientWidth
  //   ) {
  //     setShowControls(true);
  //   }
  // }, []);
  // useLayoutEffect(() => {
  //   if (performanceChartRef.current) {
  //     setWidth(performanceChartRef.current.offsetWidth + 10);
  //   }
  // }, []);
  useEffect(() => {
    const chartRef = performanceChartRef.current;

    if (chartRef && chartRef != null) {
      console.log("ChartJS", chartRef);
      // chartRef.addEventListener("wheel", (e) => {
      //   scroller(e, chartRef);
      // });
    }
  }, []);
  return (
    <>
      <DivSelectLimit screen={screen} barlength={barData?.labels.length}>
        {barData &&
        barData?.datasets &&
        Array.isArray(barData?.datasets) &&
        barData.datasets[1]?.data &&
        Array.isArray(barData.datasets[1]?.data) &&
        barData.datasets[1]?.data.length ? (
          <Bar
            ref={performanceChartRef}
            options={options}
            data={barData}
            width={barData?.labels.length * 100}
            height={400}
            plugins={[ChartDataLabels]}
            updateMode={"resize"}
            responsive={true}
          />
        ) : null}
      </DivSelectLimit>
    </>
  );
}
BarChat.propTypes = {
  data: PropTypes.array,
  barLabel: PropTypes.array,
  avgData: PropTypes.array,
  topperData: PropTypes.array,
};
export default BarChat;
